import Img, { IBackgroundImageProps } from "gatsby-background-image";
export interface BackgroundImageProps extends IBackgroundImageProps {
  src?: string;
  image: JSX.Element | string;
  className?: string | object;
  children?: string | JSX.Element | JSX.Element[];
  style?: CSSProperties;
}

function BackgroundImage(props: BackgroundImageProps) {
  return <Img {...props} fluid={props.image} />;
}

export default BackgroundImage;
